import Store from 'store/store';

let changeLog = [];

function persistChanges() {
	try {
		localStorage.setItem('prime-check-in-changes', JSON.stringify(changeLog));
	} catch (e) {}
}

export function loadChanges() {
	try {
		const changes = JSON.parse(localStorage.getItem('prime-check-in-changes'));
		if (Array.isArray(changes)) {
			changeLog.push(...changes);
			applyChanges();
		}
	} catch (e) {}
}

export function clearChanges() {
	try {
		localStorage.removeItem('prime-check-in-changes');
		changeLog = [];
	} catch (e) {}
}

export function applyChanges() {
	if (!Store.get().tickets) {
		return;
	}
	changeLog.forEach(change => {
		if (!change.t || change.t === 'status') {
			setTicketStatusRaw(change.id, change.status);
		}
		if (change.t === 'new-ticket') {
			createNewTicketRaw(change);
		}
	});
}

export function setTicketStatusRaw(ticket, status) {
	if (typeof ticket === 'string') {
		ticket = Store.get().tickets.find(t => t.id === ticket);
	}
	if (!ticket) {
		return;
	}
	return ticket.set({ status });
}

export function setTicketStatus(ticket, status) {
	const res = setTicketStatusRaw(ticket, status);
	if (res) {
		changeLog.push({ t: 'status', id: res.id, status });
		persistChanges();
	}
	return res;
}

function randomUUID() {
	try {
		return crypto.randomUUID();
	} catch (err) {
		// Support for old browsers and non-https environments
		const values = crypto.getRandomValues(new Uint8Array(31));
		let i = 0;
		// https://gist.github.com/jed/982883
		return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c => (
			(c ^ values[i++] & 15 >> c / 4).toString(16)
		));
	}
}
export function createNewTicketRaw(data) {
	const now = Date.now();
	const userId = randomUUID();
	const newTickets = [...Array(+data.count)].map(() => ({
		id: randomUUID(),
		uid: userId,
		creation: now,
		name: data.name,
		status: 'admitted',
		type: data.type
	}));
	const allTickets = processTickets((Store.get().tickets || []).concat(newTickets));
	Store.get().set('tickets', allTickets);
	data.ids = newTickets.map(t => t.id);
	return newTickets;
}

export function createNewTicket(data) {
	const newTickets = createNewTicketRaw(data);
	if (newTickets) {
		changeLog.push({ t: 'new-ticket', ...data });
		persistChanges();
	}
	return newTickets;
}

export function getChangesList() {
	return changeLog;
}
export function getStatusChangesList() {
	return changeLog.map(({ t, ...data }) => (!t || t === 'status') && data).filter(e => e);
}
export function getNewTicketsList() {
	return changeLog.map(({ t, ...data }) => t === 'new-ticket' && data).filter(e => e);
}

export function clearChangesList() {
	changeLog.length = 0;
	persistChanges();
}
export function clearStatusChangesList() {
	const oldLength = changeLog.length;
	changeLog = changeLog.filter(({ t }) => t && t !== 'status');
	if (changeLog.length !== oldLength) {
		persistChanges();
	}
}
export function clearNewTicketsList() {
	const oldLength = changeLog.length;
	changeLog = changeLog.filter(({ t }) => t !== 'new-ticket');
	if (changeLog.length !== oldLength) {
		persistChanges();
	}
}

export function processTickets(tickets) {
	const allTickets = new Map();
	const perUser = new Map();
	tickets.forEach(ticket => {
		if (!ticket?.uid) {
			return;
		}
		if (!perUser.has(ticket.uid)) {
			perUser.set(ticket.uid, 1);
		} else {
			const count = perUser.get(ticket.uid);
			if (!/\(.+\)$/i.test(ticket.name)) {
				ticket.name += ` (Guest #${count})`;
			}
			perUser.set(ticket.uid, count + 1);
		}
		allTickets.set(ticket.id, ticket);
	});
	return [...allTickets.values()];
}
